export interface ISpecOfferTerm {
    title: string,
    description: string,
    pdfTitle: string,
    pdf?: string,
}

export interface ISpecOfferPicture {
    url: string,
    urlWebp?: string,
}

export interface ISpecOfferBenefit {
    id: number,
    type: 'content' | 'router',
    title?: string,
    image?: string,
    imageLabel?: string,
    needPhone?: 0 | 1 | null,
    description?: string | null,
}

export interface ISpecOfferNavigation {
    id: number,
    type: 'promoPacket' | 'multisubscription' | 'equipment' | 'pendingConnection' | 'speedBonusWithRequest',
    globalId?: number | null,
    productId?: number | null,
    pricesV2?: {
        sort: number,
        type: number,
        duration: number | null,
        id: number,
        value: number,
    },
    category: 'routers' | 'decoders' | 'yandex-stanciya',
    shopItemId?: number,
}

export interface ISpecOfferFeature {
    text: string,
    type: string,
}

export interface ISpecOfferCost {
    full: number,
    withDiscount?: number,
    description?: string,
    firstPayment?: number,
    type: 'full' | 'month',
}

export interface ISpecOfferLabel {
    text?: string,
    textColor: string,
    color: string,
    type:
        | 'timer'
        | 'label'
        | 'status'
        | 'new'
        | 'sale',
}

export interface ISpecOfferChannel {
    id: number,
    title?: string,
    image?: string,
    themeId?: number,
    packageIds?: number[],
}

export interface IAdvertising {
    companyName: string,
    erid: string,
}

export enum EOfferState {
    CONNECTED = 1344,
    DECLINED = 1345,
    VIEWED = 1346,
    CREATED = 1347,
    NEW = 1348,
    DISCONNECTED = 1352,
    PENDING = 2267,
}

export interface ISpecOfferBenefitBanner {
    title: string,
    lightThemeImage: ISpecOfferPicture,
}

export interface ISpecOfferDetailItem {
    title: string,
    image: ISpecOfferPicture,
}

export interface ISpecOfferDetails {
    title?: string,
    items: ISpecOfferDetailItem[],
}

interface ISpecOfferPropertyItem {
    name: string,
    value: string,
}

export interface ISpecOfferProperties {
    title: string,
    items: ISpecOfferPropertyItem[],
}

export interface ISpecOffer {
    id: number,
    state: EOfferState,
    requestId: number,
    billingState: TPromoBillingState,
    paySum: number | null,
    reqStop: string,
    title: string,
    description: string,
    shortDescription: string,
    image?: ISpecOfferPicture,
    imageV2?: ISpecOfferPicture,
    backgroundImage?: ISpecOfferPicture,
    images: ISpecOfferPicture[],
    terms?: ISpecOfferTerm,
    childOffers: TPromoChildOffer[],
    backgroundColor: string,
    textColor: string | null,
    colorLabels: ISpecOfferLabel[],
    features?: ISpecOfferFeature[],
    cost?: ISpecOfferCost | null,
    navigation: ISpecOfferNavigation | null,
    benefits: ISpecOfferBenefit[],
    channels: ISpecOfferChannel[],
    advertising?: IAdvertising,
    hasInstantConnect?: boolean,
    buttonText?: string,
    benefitsV2?: ISpecOfferBenefitBanner[],
    details: ISpecOfferDetails,
    properties: ISpecOfferProperties,
    isShowNewDetail: boolean,
}

export type TPromoChildOffer = Pick<
    ISpecOffer,
    | 'id'
    | 'title'
    | 'description'
    | 'features'
    | 'terms'
    | 'cost'
    | 'benefits'
>;

export type TPromoBillingState =
    | 'created'         // stepId -> 1352
    | 'new'             // stepId -> 1348
    | 'viewed'          // stepId -> 1346
    | 'pending'         // stepId -> 2267
    | 'connected'       // stepId -> 1344
    | 'disconnected'    // stepId -> 1352
    | 'declined'        // stepId -> 1345
